import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    fetch(`${API}/articles`)
      .then((r) => r.json())
      .then((d) => setArticles(Array.isArray(d) ? d : []))
      .catch(() => setArticles([]));
  }, []);

  if (articles === null) return null; // initial load, no flicker

  return (
    <section id="blog" data-testid="blog-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-4">Conseils & expertise</div>
            <h2 className="font-serif text-4xl md:text-5xl text-md-primary font-medium leading-tight">
              Apprenez, décidez, <span className="italic">économisez.</span>
            </h2>
          </div>
          <p className="text-md-muted max-w-md text-[15px] leading-relaxed">
            Des articles concrets et actionnables pour mieux comprendre vos finances et faire les bons choix.
          </p>
        </div>

        {articles.length === 0 ? (
          <div className="text-center py-16 bg-md-bg rounded-3xl border border-md-border">
            <FileText className="w-12 h-12 mx-auto text-md-muted/40 mb-4" />
            <h3 className="font-serif text-2xl text-md-primary mb-2">Les premiers conseils arrivent bientôt</h3>
            <p className="text-md-muted max-w-md mx-auto text-sm">
              Mes prochains articles sont en préparation. En attendant, <a href="#contact" className="text-md-secondary underline">parlons directement de votre projet</a>.
            </p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {articles.map((a, i) => (
              <Link
                to={`/article/${a.slug}`}
                key={a.id}
                data-testid={`blog-card-${i}`}
                className="group bg-md-bg rounded-3xl overflow-hidden border border-md-border hover:border-md-secondary/40 hover:-translate-y-1 transition-all duration-500 flex flex-col"
              >
                <div className="relative h-52 overflow-hidden">
                  <img src={a.image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <span className="absolute top-4 left-4 bg-md-secondary text-white text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-full">
                    {a.category}
                  </span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-3 text-xs text-md-muted mb-3">
                    <span>{a.date}</span>
                    <span>•</span>
                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {a.read_time}</span>
                  </div>
                  <h3 className="font-serif text-xl text-md-primary font-medium mb-3 leading-snug group-hover:text-md-secondary transition-colors">
                    {a.title}
                  </h3>
                  <p className="text-sm text-md-muted leading-relaxed mb-5 flex-1">{a.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-md-primary group-hover:text-md-secondary">
                    Lire l'article <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
